import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
//helpers
import { convertDateToDDMMYYYY } from 'helpers';
//constant
import { choicesInvoice } from "constants";
//components
import ModalCustom from 'components/backoffice/modals/ModalCustom';
import ArticlesHeader from 'components/backoffice/headers/articles';

const InvoiceModal = ({ title, invoice = {}, show, setShow }) => {
  const { t } = useTranslation(['backoffice', 'shipping']);
  const [items, setItems] = useState([]);
  const [billing_address, setBilling_address] = useState([]);
  const [haveBilling, setHaveBilling] = useState(false);

  useEffect(() => {
    if (invoice && invoice.status) {
      const choices = choicesInvoice(t);
      if (Array.isArray(choices)) {
        const status = choicesInvoice(t).find(status => status.id === invoice.status);
        const validBilling = Object.keys(invoice.billing_address || {}).length > 0;
        setHaveBilling(validBilling);
        const billingAddress = validBilling ? {
          name: invoice.billing_address.name,
          last_name: invoice.billing_address.last_name,
          email: invoice.billing_address.email,
          phone: invoice.billing_address.phone,
          address: invoice.billing_address.address,
          postal_code: invoice.billing_address.postal_code,
          locality: invoice.billing_address.locality,
          province: invoice.billing_address.province?.nombre,
          country: invoice.billing_address.country?.label,
        } : {};
        setBilling_address(Object.entries(billingAddress));
        setItems([
          { key: t('numberInvoice'), value: `#${invoice.identifier}` },
          { key: t('name'), value: invoice.name },
          { key: t('date'), value: convertDateToDDMMYYYY(invoice.updated) },
          { key: t('state'), value: status?.value || t('faqs.none') }, 
          { key: t('orderTrans.subtotal'), value: invoice.sub_total },
          { key: t('orderTrans.ivatotal'), value: invoice.vat_total },
          { key: t('discount'), value: invoice.discount },
          { key: t('amount'), value: invoice.total },
          { key: t('promoCodes.code'), value: invoice.promo_code?.title || '-' },
          { key: t('order'), value: `#${invoice.order?.code}` },
          { key: t('empresa'), value: invoice.company?.name }
        ])
      }
    }

  }, [invoice]);

  return (
    <ModalCustom
      show={show}
      onHide={() => setShow(false)}
      title={title}
      centered={true}
      size='xl'
      classNameBody='pt-0'
    >
      <Row className='d-flex flex-wrap row-gap-3 border-grey border-end-0 border-start-0 border-bottom-0 rounded-0 pt-3'>
        {items.map((item, index) =>
          <Col md={3} key={index} className='d-flex gap-2'>
            <span>{item.key}:</span>
            <span className='span-details'>{item.value}</span>
          </Col>
        )}
        {invoice.user && (
          <Col md={12} key="user" className='d-flex gap-2'>
            <span>{t('user')}:</span>
            <span className='span-details'>{invoice.user}</span>
          </Col>
        )}
        {haveBilling && <Col md={12} className='d-flex flex-column gap-1'>
          <label>{t('orderTrans.billingAddress')}:</label>
          <div className='d-flex flex-wrap row-gap-3 border-grey p-3'>
            {billing_address.map(([id, value], index) =>
              <Col md={4} key={index} className='d-flex gap-2 pe-2'>
                <span>{t(id, { ns: 'shipping' })}:</span>
                <span className='span-details'>{value}</span>
              </Col>)}
          </div>
        </Col>}
        {invoice.articles && <div className='d-flex flex-column gap-1'>
          <label>{t('exports.articles')}:</label>
          <Col md={12} className='d-flex flex-row p-2 border-grey bg-grey gap-3'>
            <ArticlesHeader />
          </Col>
          {invoice.articles.map((article) => (<Col md={12} className='d-flex flex-row p-2 gap-3'>
            <ArticlesHeader articles_texts={article} />
          </Col>))}
        </div>}
      </Row>
    </ModalCustom>
  );
};

InvoiceModal.prototype = {
  title: PropTypes.string,
  invoice: PropTypes.object,
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired
};

export default InvoiceModal;
